import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Device } from './../../../common/interfaces/item.interface';
import { CommonProgrammingContext } from './../../../common/services/shared-programming.service';
import { Event } from './../../../common/interfaces/event.interface';
import { BaseRoutingComponent } from './../../../common/base-routing/base-routing.component';
import { ProgrammingUtilsService as Utils } from './../../../common/services/utils.service';
import { SharedProgrammingService } from '../../../common/services/shared-programming.service';
import { DeviceEvent } from '../../../common/interfaces/event.interface';

@Component({
  selector: 'prg-select-interaction',
  templateUrl: './select-interaction.component.html',
  styleUrls: ['./select-interaction.component.less']
})
export class SelectInteractionComponent extends BaseRoutingComponent implements OnInit {

  @Input() iconClass: string;

  device: Observable<Device>;
  events: Observable<Event[]>;
  ready: Observable<boolean>;

  constructor(
    protected router: Router,
    protected store: Store<{ sharedProgramming: CommonProgrammingContext }>,
    private route: ActivatedRoute,
    private utils: Utils,
    private shared: SharedProgrammingService
  ) {
    super();
    this.device = this.store.select(s => s.sharedProgramming.trigger.device);
    this.events = this.store.select(s => s.sharedProgramming.trigger.events);
    this.ready = this.shared.isReady;
  }

  ngOnInit() {
    this.iconClass = this.route.snapshot.data['iconClass'];
  }

  selectEvent(event: DeviceEvent) {
    this.router.navigate(['when-then','device', event.deviceId, 'event', event.eventId, 'add'], { relativeTo: this.moduleRoot });
  }

  goHome() {
    this.router.navigate(['../programming'], { relativeTo: this.moduleRoot });
  }
}




// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-common/select-interaction/select-interaction.component.ts